import { withAsync } from '@/components/Async'
import { Blank } from '@/layouts/Blank'
const routes = [
  {
    path: '/middleware',
    component: Blank,
    routes: [
      {
        path: '/station',
        component: withAsync(() => import(/* webpackChunkName: "Order/Station" */ '@/containers/Order/Station')),
        exact: true,
      },
    ],
  },
]

export default routes
